export default {
  tcVariables: state => state.tcVariables
};